/**
 * @generated SignedSource<<4f3a66cae1b36513a5bd3deef2eab27d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceStarActionButtonSpaceFragment$data = {
  readonly currentUser: {
    readonly isFavourited: boolean;
  };
  readonly " $fragmentType": "SpaceStarActionButtonSpaceFragment";
};
export type SpaceStarActionButtonSpaceFragment$key = {
  readonly " $data"?: SpaceStarActionButtonSpaceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceStarActionButtonSpaceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceStarActionButtonSpaceFragment",
  "selections": [
    {
      "concreteType": "SpaceUserMetadata",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourited"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "8952ed3b4f2eb093d58223c1da19fdac";

export default node;
